import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import {
  mainFontFamily, ssColorWhite, ssColorBlack,
} from '../constants/style-constants';
import { hunit, vunit } from '../lib/style-helpers';
import LoadingSpinnerIcon from './icons/LoadingSpinnerIcon';
import { Paragraph } from './Typography';

const overlayCss = css`
  position: fixed;
  background: ${ssColorBlack};
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1;
`;

const descriptionCss = css`
  color: ${ssColorWhite};
  font-size: 0.9rem;
  margin-top: ${vunit(1)};
  text-align: center;
  text-transform: uppercase;
`;

const contentCss = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  left: 0;
  padding: 0 ${hunit(4)};
  position: absolute;
  top: 0;
  width: 100%;

  h1 {
    color: ${ssColorWhite};
    font-family: ${mainFontFamily};
    font-size: 1.4rem;
    font-weight: normal;
    text-align: center;
    text-transform: none;
  }
`;

/* eslint-disable quotes */
const hideShowCss = isVisible => css`
  display: ${isVisible ? "block" : "none"};
`;
/* eslint-enable quotes */

const LoadingOverlay = ({
  title, message, displayDuration, show,
}) => {
  const [overlayVisible, showOverlay] = useState(show);

  useEffect(() => {
    if (!displayDuration) return;

    const hideTimerId = setTimeout(() => showOverlay(false), displayDuration);

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(hideTimerId);
    };
  }, [displayDuration, show]);

  return (
    <div
      role="dialog"
      aria-labelledby="description"
      aria-describedby="title"
      css={[overlayCss, hideShowCss(overlayVisible)]}
    >
      <div css={contentCss}>
        <h1 id="title">{title}</h1>
        <Paragraph id="description" css={descriptionCss}>{message}</Paragraph>
        <LoadingSpinnerIcon />
      </div>
    </div>
  );
};

LoadingOverlay.defaultProps = {
  displayDuration: 2500,
  show: true,
};

LoadingOverlay.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  displayDuration: PropTypes.number,
  show: PropTypes.bool,
};

export default LoadingOverlay;
